import React from "react";
import { withRouter } from "react-router-dom";
import Edititemform from "./components/Edititemform";
function Edititem() {
  return <Edititemform></Edititemform>;
}
export default withRouter(Edititem);
